
import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy/page'));
const SMSOptInPage = lazy(() => import('../pages/sms-opt-in/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

import SmsOptInPage from '../pages/sms-opt-in/page';
import SmsOptOutPage from '../pages/sms-opt-out/page';
import CodeOfConduct from '../pages/code-of-conduct/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <HomePage />
      </Suspense>
    ),
  },
  {
    path: '/privacy',
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <PrivacyPolicyPage />
      </Suspense>
    ),
  },
  {
    path: '/sms-opt-in',
    element: <SmsOptInPage />
  },
  {
    path: '/sms-opt-out',
    element: <SmsOptOutPage />
  },
  {
    path: '/code-of-conduct',
    element: <CodeOfConduct />,
  },
  {
    path: '*',
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <NotFoundPage />
      </Suspense>
    ),
  },
];

export default routes;
